import "./Gallery.module.css";
import Navbar from "@/reusable_sections/Header";
import Gallery from "./sections/Gallery";
import Booking from "./sections/Booking";
import Footer from "@/reusable_sections/Footer";
export default function GalleryPage() {
  return <div>
      <Navbar />
      <Gallery />
      <Booking />
      <Footer />
    </div>;
}